import {
  CE_VIEW_WEB_VERSION_OPEN,
  CE_VIEW_WEB_VERSION_ERROR,
  CE_VIEW_WEB_VERSION_READY,
  CE_VIEW_WEB_VERSION_TOGGLE_REPLACEMENT_CODES,
} from "@js/actions/studio/campaign_content_section/screen_view_web_version.js";

import { newScreen, mergeScreenState, getContent } from "@js/helpers/state.js";

export default (state = {}, action) => {
  switch (action.type) {
    case CE_VIEW_WEB_VERSION_OPEN: {
      return newScreen(state, "view_web_version", {
        is_loading: true,
        is_error: false,
        show_replacements: false,
        plain_html: null,
        replaced_html: null,
      });
    }

    case CE_VIEW_WEB_VERSION_READY: {
      return newScreen(state, "view_web_version", {
        is_loading: false,
        is_error: false,
        show_replacements: false,
        plain_html: action.plain_html,
        replaced_html: action.replaced_html,
      });
    }

    case CE_VIEW_WEB_VERSION_TOGGLE_REPLACEMENT_CODES: {
      return mergeScreenState(state, {
        show_replacements: !state.screen.state.show_replacements,
      })
    }

    case CE_VIEW_WEB_VERSION_ERROR: {
      return newScreen(state, "view_web_version", {
        is_loading: false,
        is_error: true,
        show_replacements: false,
        plain_html: null,
        replaced_html: null,
      });
    }

    default:
      return state;
  }
};
